<section class="perm-search" aria-live="polite">
  <header class="perm-search__header">
    <div class="perm-search__heading">
      <h2 class="perm-search__title">
        {{ values().length }} {{ values().length === 1 ? 'resultado' : 'resultados' }} para “{{
          query()
        }}”
      </h2>
      @if (values().length) {
        <p class="perm-search__subtitle">
          {{ selectedCount() }} {{ selectedCount() === 1 ? 'ligada' : 'ligadas' }} em
          {{ screenCount() }} {{ screenCount() === 1 ? 'tela' : 'telas' }} · os botões valem só para
          os resultados
        </p>
      }
    </div>
    @if (values().length) {
      <div class="perm-search__bulk">
        <app-button
          [id]="'search-mark-all'"
          [label]="'Marcar os ' + values().length"
          size="small"
          theme="white"
          [noMargin]="true"
          (sendButtonClick)="setAll(true)"></app-button>
        <app-button
          [id]="'search-unmark-all'"
          [label]="'Desmarcar os ' + values().length"
          size="small"
          theme="white"
          [noMargin]="true"
          (sendButtonClick)="setAll(false)"></app-button>
      </div>
    }
  </header>

  <div class="perm-search__body">
    @for (result of results(); track result.screen.id) {
      <div class="perm-search__group">
        <div class="perm-search__group-head">
          <h3>{{ result.screen.label }}</h3>
          <span class="perm-search__path">{{ result.screen.path.join(' › ') }}</span>
          <button type="button" class="perm-search__open" (click)="screenOpen.emit(result.screen)">
            Abrir a tela inteira
          </button>
        </div>
        <div class="perm-search__actions">
          @for (action of result.actions; track action.value) {
            <app-permission-action-row
              class="perm-search__action"
              [action]="action"
              [query]="query()"
              [checked]="isChecked(action)"
              [changed]="isChanged(action)"
              [showKind]="true"
              [showGroup]="result.screen.groupNames.length > 1"
              (checkedChange)="
                valueChange.emit({ value: action.value, checked: $event })
              "></app-permission-action-row>
          }
        </div>
      </div>
    } @empty {
      <div class="perm-search__empty">
        <i class="pi pi-search"></i>
        <p>Nenhuma permissão ou tela com “{{ query() }}”.</p>
        <p class="perm-search__empty-hint">
          Tente outro termo, como o nome da tela no menu (“Empréstimos”) ou uma ação (“anexo”,
          “excluir”).
        </p>
        <app-button
          [id]="'search-clear'"
          label="Limpar busca"
          size="small"
          theme="white"
          [noMargin]="true"
          (sendButtonClick)="clearSearch.emit()"></app-button>
      </div>
    }
  </div>
</section>
